import React, { useState } from 'react';
import css from './SectionSchoolHero.module.css';

import TalentRoaster from './TalentRoaster';
import PostedContent from './PostedContent';
import CampaignShowCase from './CampaignShowCase';
import SocialMediaFeeds from './SocialMediaFeeds';
import SchoolCustomLinks from './SchoolCustomLinks';

const SectionGroupHeroSubTabs = {
  CUSTOM_LINKS: 'CUSTOM_LINKS',
  SOCIAL_MEDIA_FEEDS: 'SOCIAL_MEDIA_FEEDS',
  TALENT_ROSTER: 'TALENT_ROSTER',
  CAMPAIGN_SHOWCASE: 'CAMPAIGN_SHOWCASE',
  POSTED_CONTENT: 'POSTED_CONTENT',
};

const SectionGroupPlus = ({
  publicData,
  schoolInlineBanner,
  subscriptionRequiredBanner,
  showGroupPlusData = false,
  showInlineBanner = false,
}) => {
  const [activeTab, setActiveTab] = useState(SectionGroupHeroSubTabs.CUSTOM_LINKS);

  const renderTabContent = () => {
    switch (activeTab) {
      case SectionGroupHeroSubTabs.CUSTOM_LINKS:
        return <SchoolCustomLinks publicData={publicData} />;
      case SectionGroupHeroSubTabs.SOCIAL_MEDIA_FEEDS:
        return <SocialMediaFeeds publicData={publicData} />;
      case SectionGroupHeroSubTabs.TALENT_ROSTER:
        return <TalentRoaster publicData={publicData} />;
      case SectionGroupHeroSubTabs.CAMPAIGN_SHOWCASE:
        return <CampaignShowCase publicData={publicData} />;
      case SectionGroupHeroSubTabs.POSTED_CONTENT:
        return <PostedContent publicData={publicData} />;
      default:
        return null;
    }
  };

  return (
    <div className={css.sectionGroupPlus}>
      {/* 1. Subscription banner – always try to show if passed */}
      {subscriptionRequiredBanner}

      {showInlineBanner && schoolInlineBanner}

      {/* 2. Tabs + content – only render when we have data to show */}
      {showGroupPlusData && (
        <>
          <div className={css.tabHeader}>
            {Object.values(SectionGroupHeroSubTabs).map(label => (
              <button
                key={label}
                className={`${css.tabButton} ${activeTab === label ? css.active : ''}`}
                onClick={() => setActiveTab(label)}
              >
                {label.replace(/_/g, ' ')}
              </button>
            ))}
          </div>

          <div className={css.tabContent}>{renderTabContent()}</div>
        </>
      )}
    </div>
  );
};

export default SectionGroupPlus;
